import React, { Component } from 'react';
import './AccountMenu.css';
import FontIcon from '../fontIcon/FontIcon';
import Label from '../label/Label';
import Card from '../card/Card';
import Divider from '../divider/Divider';
import models from '../../model/models';
import history from '../../history';

export default class AccountMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			openMenu: false,
			user: models.user.getCurrent()
		};
	}

	componentDidMount = () => {
		this.subscribeId = models.user.onCurrentChange(this._setUser);
		this.subscribeGroupId = models.user_group.onChange(this._setUser);
		this._setUser();
		document.body.addEventListener(
			'click',
			() => {
				if (this.state.openMenu) {
					setTimeout(this._closeMenu, 100);
				}
			},
			true
		);
	};

	componentWillUnmount = () => {
		models.user.unsubscribe(this.subscribeId);
		models.user_group.unsubscribe(this.subscribeGroupId);
	};

	_setUser = () => {
		this.setState({ user: models.user.getCurrent(), userGroup: models.user_group.obj() });
	};

	_openMenu = () => {
		this.setState({ openMenu: true });
	};

	_closeMenu = () => {
		this.setState({ openMenu: false });
	};

	_toggleMenu = () => {
		this.setState({ openMenu: !this.state.openMenu });
	};

	_logout = () => {
		delete localStorage.token;
		delete localStorage.user_group_id;
		delete localStorage.num_additional_groups;
		localStorage.clear();
		this._closeMenu();
		history.navigate('/login');
	};

	_navigateSettings = () => {
		this._closeMenu();
		history.navigate('/settings');
	};

	_navigateSuperAdminSettings = () => {
		this._closeMenu();
		history.navigate('/super/admin/settings');
	};

	canSelectWithTab = () => {
		if(!localStorage.token) return -1;
		else if(localStorage.token){
			return 0;
		}
		else{
			return -1;
		}
	}

	_renderMenu = () => {
		if (!this.state.openMenu) return;
		let user = this.state.user || {};
		let userGroup = this.state.userGroup || {};
		return (
			<Card className="menu">
				<Label black bold>
					{user.first_name + ' ' + user.last_name}
				</Label>
				<Label gray-dark>{user.primary_email}</Label>
				<Label medium-small>{userGroup.name}</Label>
				<Divider />
				<Label tabIndex="0" gray-dark onClick={this._navigateSettings}>
					{/* <div tabIndex="0" /> */}
					{' '}
					Settings
				</Label>
				<Divider />
				{this._renderSuperAdminLink()}
				<Label tabIndex="0" gray-dark onClick={this._logout}>
					{/* <div tabIndex="0" /> */}
					Log-out
				</Label>
			</Card>
		);
	};

	_renderSuperAdminLink = () => {
		let { user = {} } = this.state;
		if (user.role === 'super_admin') {
			return [
				<Label tabIndex="0" key={0} gray-dark onClick={this._navigateSuperAdminSettings}>
					Super Admin Settings
				</Label>,
				<Divider key={1} />
			];
		}
	};

	render() {
		return (
			<div className="g-account-menu">
				<div tabIndex={this.canSelectWithTab()} className="account" onClick={this._toggleMenu}>
					<Label tabIndex={this.canSelectWithTab()} blue={this.state.openMenu} gray-medium={!this.props.openMenu}>
						Account <FontIcon name="icon-chevron-right" />{' '}
					</Label>
				</div>
				{this._renderMenu()}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/accountMenu/AccountMenu.jsx